"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _colours = _interopRequireDefault(require("./colours"));

var Theme = {
  '$background-color': _colours["default"].white,
  '$background-alt-color': _colours["default"].snow,
  '$link-color': _colours["default"].azure,
  '$inactive-link-color': _colours["default"].ash,
  '$shadow-color': 'rgba(0,0,0,0.14)',
  '$panel-border-color': _colours["default"].smoke,
  '$panel-background-color': _colours["default"].smoke,
  // Text
  '$text-color': _colours["default"].raisin,
  '$text-color-light': _colours["default"].white,
  '$heading-color': _colours["default"].charcoal,
  '$placeholder-color': _colours["default"].ash,
  '$error-text-color': _colours["default"].watermelon,
  '$warning-text-color': _colours["default"].lemon,
  // Table
  '$table-border-color': _colours["default"].wolf,
  '$table-heading-color': _colours["default"].cloud,
  '$table-footing-color': _colours["default"].cloud,
  '$table-new-row': _colours["default"].honeydew,
  '$table-disabled': _colours["default"].snow,
  '$table-background-color': _colours["default"].white,
  '$table-selected-color': _colours["default"].baby,
  '$table-odd-background-color': _colours["default"].snow,
  // NEW Table
  '$table-border-color-new': '#EEEEEE',
  '$table-row-hover': _colours["default"].snow,
  '$table-footer-text-color-new': _colours["default"].raisin,
  '$table-heading-color-new': '#F6F6F6',
  '$table-footing-color-new': '#F6F6F6',
  // Input
  '$input-background': _colours["default"].snow,
  '$input-background-focus': _colours["default"].cloud,
  '$input-background-light': _colours["default"].white,
  '$input-background-error': _colours["default"].blush,
  '$input-background-warning': _colours["default"].buttermilk,
  // Button backgrounds
  '$button-color': _colours["default"].snow,
  '$button-color-active': _colours["default"].cloud,
  '$button-primary-color': _colours["default"].shamrock,
  '$button-primary-color-active': '#25C48B',
  '$button-secondary-color': _colours["default"].ash,
  '$button-secondary-color-active': '#9FA2A2',
  '$button-negative-color': _colours["default"].watermelon,
  '$button-negative-color-active': '#FC4D5F',
  // Indicator
  '$indicator-green': _colours["default"].shamrock,
  '$indicator-grey': _colours["default"].wolf,
  '$indicator-white': _colours["default"].white,
  // Menu
  '$menu-border-color': _colours["default"].wolf,
  '$menu-highlight-background-color': _colours["default"].cloud,
  '$menu-active-background-color': _colours["default"].baby,
  '$menu-background-color': _colours["default"].white,
  // Popover
  '$popover-background': _colours["default"].raisin,
  '$popover-text-color': _colours["default"].white,
  // Fonts
  '$font-default': 'Roboto',
  '$font-heading': 'Quicksand',
  // InfoBox
  '$infobox-background': _colours["default"].buttermilk,
  '$infobox-background-active': _colours["default"].honeydew,
  // Overlay
  '$overlay-background': _colours["default"].white,
  // Toggle Switch
  '$toggle-switch-background': _colours["default"].wolf,
  '$toggle-switch-checked': _colours["default"].azure,
  '$toggle-switch-slider': _colours["default"].white,
  // Pill
  '$pill-default-color': _colours["default"].snow,
  '$pill-main': _colours["default"].shamrock,
  '$pill-secondary': _colours["default"].ash,
  '$pill-negative': _colours["default"].watermelon,
  '$pill-highlight': _colours["default"].azure,
  '$pill-alert': _colours["default"].lemon,
  // Bar chart
  '$bar-chart-primary': _colours["default"].azure,
  '$bar-chart-primary-alt': '#368EF866',
  '$bar-chart-secondary': _colours["default"].shamrock,
  '$bar-chart-secondary-alt': '#2dd79966',
  '$bar-chart-tertiary': _colours["default"].lemon,
  '$bar-chart-tertiary-alt': '#FEDF1A66',
  '$bar-chart-quaternary': _colours["default"].prince,
  '$bar-chart-quaternary-alt': '#4129AC66',
  '$bar-chart-border-color': _colours["default"].charcoal,
  '$bar-chart-horizontal-border-color': _colours["default"].wolf,
  // Parcentage Bar
  '$toggle-percent-bar-primary': _colours["default"].shamrock,
  '$toggle-percent-bar-secondary': _colours["default"].watermelon,
  '$toggle-percent-bar-tertiary': _colours["default"].azure,
  '$toggle-percent-bar-quaternary': _colours["default"].lemon,
  // Sidebar
  '$sidebar-arrow-color': _colours["default"].raisin,
  '$sidebar-background-color': _colours["default"].white,
  '$sidebar-active-color': _colours["default"].baby,
  '$sidebar-odd-color': _colours["default"].snow,
  // Dropdown
  '$dropdown-active-item': _colours["default"].azure,
  '$dropdown-lite-background': _colours["default"].white,
  '$dropdown-lite-active': _colours["default"].snow,
  // Loader
  '$loading-pulse-color': _colours["default"].wolf,
  '$loader-border': _colours["default"].charcoal,
  // Button icon
  '$button-icon-main': _colours["default"].white,
  '$button-icon-alt': _colours["default"].charcoal,
  // Extensible Dropdown
  '$extensible-dropdown-background': _colours["default"].white,
  // Calendar
  '$calendar-icon': _colours["default"].azure,
  '$calendar-selected': _colours["default"].azure,
  '$calendar-current': _colours["default"].ash,
  '$calendar-hovered': _colours["default"].baby,
  // Breadcrumb
  '$breadcrumb-icon-color': _colours["default"].azure,
  '$breadcrumb-background-color': _colours["default"].snow,
  '$breadcrumb-link-border-color': _colours["default"].wolf,
  // Texteditor
  '$texteditor-icon': _colours["default"].ash,
  '$texteditor-icon-active': _colours["default"].raisin,
  // CopyText
  '$copy-text-background': _colours["default"].snow,
  // Datepicker
  '$date-picker-border-color': _colours["default"].wolf,
  '$date-picker-heading-color': _colours["default"].cloud,
  // Date range picker
  '$date-range-picker-overlay-color': _colours["default"].wolf,
  '$date-range-picker-border-color': _colours["default"].cloud,
  // Gauge
  '$gauge-background-color': _colours["default"].white,
  // Tile
  '$tile-background': _colours["default"].snow,
  '$tile-remove-color': _colours["default"].watermelon,
  '$tile-button-active-color': '#FC4D5F',
  // Tab
  '$tab-background-color': _colours["default"].smoke,
  '$tab-active-color': _colours["default"].white,
  // Pill selection
  '$pillselection-selected': _colours["default"].white,
  '$pillselection-background': _colours["default"].smoke,
  //List Selector
  '$list-selector-background-even-color': _colours["default"].snow,
  '$list-selector-text-color': _colours["default"].azure,
  '$list-selector-selected-color': _colours["default"].raisin,
  '$list-selector-selected-background-color': _colours["default"].baby,
  // Z-index master list
  // -------------------------
  // Used for a bird's eye view of components dependent on the z-axis
  '$z-index-dropdown': 1060,
  '$z-index-overlay': 1050
};
var _default = Theme;
exports["default"] = _default;
//# sourceMappingURL=index.js.map